import { render, staticRenderFns } from "./EmployeeRegistrationModal.vue?vue&type=template&id=dc30c960&scoped=true&"
import script from "./EmployeeRegistrationModal.vue?vue&type=script&lang=ts&"
export * from "./EmployeeRegistrationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc30c960",
  null
  
)

export default component.exports